export default __webpack_public_path__ + "7a74811be3d458ca0511add35577e1f7.svg";